import type { IStoreInfo } from '@/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IStoreInfoProps {
  store: IStoreInfo;
}

export const StoreInfo: React.FC<IStoreInfoProps> = ({ store }): JSX.Element => {
  const { t } = useTranslation();

  const { city, countryCode, email, name, phoneNumber, streetAddress, zipCode } = store;

  return (
    <Box>
      <Text textTransform="uppercase">{t('STORE.INFOBOX_TITLE')}</Text>
      <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
        {name}
      </Text>
      <Text>
        {streetAddress}
        <br /> {zipCode} {city} {countryCode}
      </Text>
      <Text mt={4}>
        {t('STORE.PHONE_NUMBER')} {phoneNumber}
        <br /> {t('STORE.MAIL')} {email}
      </Text>
    </Box>
  );
};
